import { PatientGuarantor } from "pwapi";

import AdminPanel from "components/admin/adminPanel/AdminPanel";
import HalfScreenPanel from "components/admin/editPanels/halfScreenEditPanel/HalfScreenPanel";
import DjangoLink from "components/DjangoLink";

import GuarantorForm from "./GuarantorForm";

type GuarantorPanelProps = {
  setEditGuarantor: Function;
  patientId: number;
  guarantor: PatientGuarantor;
  canUpdateGuarantor?: boolean;
};

const GuarantorPanel = ({
  setEditGuarantor,
  guarantor,
  patientId,
  canUpdateGuarantor = true,
}: GuarantorPanelProps) => {
  const handleOnClose = () => {
    setEditGuarantor(undefined);
  };

  return (
    <HalfScreenPanel onClose={handleOnClose}>
      <div className="HalfScreen__container">
        <AdminPanel
          title={{
            main: `${guarantor.id ? "Update" : "New"} Patient Guarantor`,
          }}
          djangoLink={
            <DjangoLink
              route={`pathology/patientguarantor/${guarantor.id}/change/`}
              title="Django Guarantor Access"
            />
          }
        >
          <GuarantorForm
            guarantor={guarantor}
            patientId={patientId}
            onClose={handleOnClose}
            disableSubmit={!canUpdateGuarantor}
          />
        </AdminPanel>
      </div>
    </HalfScreenPanel>
  );
};

export default GuarantorPanel;
